export const urls = {
  kwsHome: 'https://www.kidswebservices.com/en-US',
  kwsTermsOfUse: 'https://www.kidswebservices.com/en-US/terms-of-use',
  kwsPrivacyPolicy: 'https://www.kidswebservices.com/en-US/privacy-policy',
}

export const KWS_SUPPORTED_LANGS = [
  {value: 'en', label: 'English'},
  {value: 'ar', label: 'العربية'},
  {value: 'bg', label: 'български'},
  {value: 'cs', label: 'čeština'},
  {value: 'da', label: 'dansk'},
  {value: 'de', label: 'Deutsch'},
  {value: 'el', label: 'Ελληνικά'},
  {value: 'es', label: 'español'},
  {value: 'es-MX', label: 'español de México'},
  {value: 'fi', label: 'suomi'},
  {value: 'fil', label: 'Filipino'},
  {value: 'fr', label: 'français'},
  {value: 'hi', label: 'हिंदी'},
  {value: 'hu', label: 'magyar'},
  {value: 'id', label: 'Bahasa Indonesia'},
  {value: 'it', label: 'italiano'},
  {value: 'ja', label: '日本語'},
  {value: 'ko', label: '한국어'},
  {value: 'ms', label: 'Bahasa Melayu'},
  {value: 'nl', label: 'Nederlands'},
  {value: 'no', label: 'norsk'},
  {value: 'pl', label: 'polski'},
  {value: 'pt', label: 'português'},
  {value: 'pt-BR', label: 'português do Brasil'},
  {value: 'ro', label: 'română'},
  {value: 'ru', label: 'русский'},
  {value: 'sv', label: 'svenska'},
  {value: 'th', label: 'ภาษาไทย'},
  {value: 'tl', label: 'Tagalog'},
  {value: 'tr', label: 'Türkçe'},
  {value: 'uk', label: 'українська'},
  {value: 'vi', label: 'Tiếng Việt'},
  {value: 'zh-Hans', label: '简体中文'},
  {value: 'zh-Hant', label: '繁體中文'},
]
